import React, { useEffect, useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth"; 
import Header from "../../components/Header";
import "./AdminLogin.css";

const AdminLogin = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const [user, loadingAuthState] = useAuthState(auth);
  const navigate = useNavigate();

  // 🔁 Redirect if already logged in
  useEffect(() => {
    if (user && !loadingAuthState) {
      navigate("/eventDashboard");
    }
  }, [user, loadingAuthState, navigate]);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      await signInWithEmailAndPassword(auth, formData.email, formData.password);
      setStatus("Login successful");
      navigate("/eventDashboard");
    } catch (error) {
      console.error("Login error", error);
      setStatus("Login failed: " + error.message);
    }

    setLoading(false);
  };

  // Show nothing while checking auth state
  if (loadingAuthState) return null;

  return (
    <div>
      <Header />
      <div className="admin-container">
        <div className="admin-login-box">
          <h2>Admin Login</h2>
          <form className="admin-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">
                Email<span className="required">*</span>
              </label>
              <input
                type="email"
                name="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">
                Password<span className="required">*</span>
              </label>
              <input
                type="password"
                name="password"
                id="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
            {status && <p className="status">{status}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
